import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { AuthService } from '../../../services/auth.service';

@Injectable()
export class InvoicesCosmoGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
      console.log('Can activate Invoices Cosmo');
    return this.authService.userHasPermission('app.invoices.cosmo');
  }
}



// WEBPACK FOOTER //
// ./src/app/invoices/invoices-cosmo/guards/invoices-cosmo.guard.ts